import { render, staticRenderFns } from "./vue-autocomplete.vue?vue&type=template&id=cffa6454&"
import script from "./vue-autocomplete.vue?vue&type=script&lang=js&"
export * from "./vue-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./vue-autocomplete.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports